export default function Votes() {
    return (
        <div>
            <h1>votes</h1>
            <h6>user\Votes.jsx</h6>
        </div>
    )
}